import { getFieldErrors } from './getFieldErrors';

/**
 * @deprecated Since it doesn't employ any side effects, this should not be a
 * hook. Use transform function `getFieldErrors` instead.
 */
export const useFieldErrors = getFieldErrors;
